import React, { useEffect, useState } from 'react'
import {messages} from '../../config/config'
import useAuth from '../../hooks/useAuth'
import { useConfig } from '../../contexts/ConfigContext'
import { useSecureRequest } from '../../hooks/useSecureRequest'
import { UserOutlined } from "@ant-design/icons";
import { Button, Card, Col, Form, Input, Layout, Row, Spin } from 'antd'
import { Content } from 'antd/es/layout/layout'
import FooterLayout from '../Footer';

function ForgotPassword(){
  const {tokenData} = useAuth.useToken()
  const {config,updateConfig} = useConfig()
  const {securePost} = useSecureRequest()
  const [spinning, setSpinning] = useState(true)
  const [form] = Form.useForm();
  const {
    content,
    error
  } = useAuth.useIndex(tokenData)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 500);

  useEffect(()=>{
    if(tokenData && content) {
      updateConfig({...content, key:tokenData.key, token:tokenData.token})
      setSpinning(false)
    }
    const handleResize = () => setIsMobile(window.innerWidth < 500);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  },[tokenData,content])

  if(error){
    alert('No fue posible conectar con el servidor')
    setSpinning(false)
  } 
  const handleForgot = async (values:any) => {
    setSpinning(true)
    const forgotResponse = await securePost('/security/auth/forgot-password',{email:values.username})
    if(forgotResponse.status === 200){
      updateConfig({
        errorMessage: forgotResponse.errorMessage || forgotResponse.message
      })
      form.setFieldsValue({username:''})
    }else{
      updateConfig({
        errorMessage: messages.login.default.alert
      })
    }
    setSpinning(false)
  }
  return (
    <Layout style={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Spin size="large" tip="Cargando..." fullscreen spinning={spinning} />
      <Content style={{width: "100%", display: "flex", justifyContent: "center", alignItems: "center", padding: 10 }}>
        <Card style={{width: "90%", maxWidth: 800, minHeight: "70vh", display: "flex", flexDirection: "column", justifyContent: "center", margin: 40,boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.2)",borderRadius: 12}}>
        <Row justify="center" gutter={16}>
          <Col xs={20} sm={14} md={14} lg={9} xl={10}>
            
              {/* Contenedor flexible para alinear elementos */}
              <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", alignItems: "center" }}>
                {/* Formulario */}
                <div style={{ flex: 1, padding: 20 }}>
                  <h4 className="title-login" style={{ textAlign: "center" }}>{config.title}</h4>
                  <p style={{marginBottom:"1.5rem",color:"#858796",textAlign:"center"}}>{config.message}</p>
                  <Form form={form} layout="vertical" onFinish={handleForgot}>
                    <Form.Item label="" name="username" rules={[{required:true,min:8,message:"Por favor ingrese un correo válido",type:"email"}]}>
                      <Input prefix={<UserOutlined />} style={{borderRadius:"2rem", padding:"1rem 1.2rem",fontSize:"0.8rem"}} minLength={8} placeholder={messages.forgotPassword.default.form.emailPlaceholder} />
                    </Form.Item>
                    <Form.Item>
                      <Button type="primary" htmlType="submit" disabled={!(config.enableForgot)} block style={{borderRadius:"10rem",padding:"20px"}}>
                        {messages.forgotPassword.default.form.buttonText}
                      </Button>
                    </Form.Item>
                  </Form>
                  <div style={{textAlign:"center"}}>
                    <h4 style={{color:"red"}}>{(config.errorMessage) || ''}</h4>
                  </div>
                  <hr />
                  <div style={{textAlign:"center"}}>
                    <a style={{fontSize:"80%",fontWeight:400}} href="/login">
                    {messages.forgotPassword.default.accountText}
                    </a>
                  </div>
                </div>
              </div>
          </Col>
          <Col xs={0} sm={0} md={0} lg={10} xl={11}>
            {/* Imagen (Solo en pantallas grandes) */}
            {!isMobile && (
              <div className="bg-image image-forgot">
              </div>
            )}
          </Col>
        </Row>
        </Card>
      </Content>

      <FooterLayout />
    </Layout>
  )
}

export default ForgotPassword